"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
require("../Styles/Overlay.css");
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    function Overlay(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState({
                isVisable: !_this.state.isVisable
            });
        };
        _this.state = {
            isVisable: _this.props.isVisable
        };
        return _this;
    }
    Overlay.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isVisable != this.props.isVisable) {
            this.setState({
                isVisable: this.props.isVisable
            });
        }
    };
    Overlay.prototype.render = function () {
        return (React.createElement(reactstrap_1.Modal, { isOpen: this.state.isVisable, toggle: this.toggle, className: "overlay", backdrop: "static", keyboard: false }, this.props.children));
    };
    return Overlay;
}(React.Component));
exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.js.map